var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "header",
        { staticStyle: { "padding-top": "10px", "padding-left": "20px" } },
        [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c(
                "svg",
                {
                  staticStyle: { "margin-right": "4px", "margin-top": "-7px" },
                  attrs: {
                    width: "17",
                    height: "17",
                    viewBox: "0 0 17 17",
                    fill: "none",
                    xmlns: "http://www.w3.org/2000/svg"
                  }
                },
                [
                  _c("path", {
                    attrs: {
                      d:
                        "M8.49946 17C9.51853 17 10.3961 16.3844 10.7811 15.5059H6.21777C6.60283 16.3844 7.48042 17 8.49946 17Z",
                      fill: "#3C434D"
                    }
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d:
                        "M13.6465 8.22979V7.13867C13.6465 4.82036 12.1055 2.85544 9.99418 2.21365V1.49414C9.99418 0.670272 9.32391 0 8.50004 0C7.67617 0 7.0059 0.670272 7.0059 1.49414V2.21365C4.89451 2.85544 3.35355 4.82033 3.35355 7.13867V8.22979C3.35355 10.2662 2.57733 12.1972 1.16789 13.667C1.02977 13.811 0.990953 14.0236 1.06925 14.2071C1.14754 14.3907 1.32783 14.5098 1.52738 14.5098H15.4727C15.6722 14.5098 15.8525 14.3907 15.9308 14.2071C16.0091 14.0236 15.9703 13.811 15.8322 13.667C14.4227 12.1972 13.6465 10.2662 13.6465 8.22979ZM8.99809 2.01636C8.83416 2.00055 8.66805 1.99219 8.50004 1.99219C8.33203 1.99219 8.16592 2.00055 8.00199 2.01636V1.49414C8.00199 1.21952 8.22542 0.996094 8.50004 0.996094C8.77466 0.996094 8.99809 1.21952 8.99809 1.49414V2.01636Z",
                      fill: "#3C434D"
                    }
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d:
                        "M14.9749 7.13844C14.9749 7.4135 15.1979 7.63649 15.4729 7.63649C15.748 7.63649 15.971 7.4135 15.971 7.13844C15.971 5.14294 15.1939 3.26686 13.7828 1.85583C13.5884 1.66136 13.273 1.66132 13.0785 1.85583C12.884 2.05033 12.884 2.36566 13.0785 2.56016C14.3014 3.78307 14.9749 5.40899 14.9749 7.13844Z",
                      fill: "#3C434D"
                    }
                  }),
                  _vm._v(" "),
                  _c("path", {
                    attrs: {
                      d:
                        "M1.52734 7.63647C1.8024 7.63647 2.02539 7.41348 2.02539 7.13842C2.02539 5.409 2.69888 3.78308 3.92175 2.56018C4.11626 2.36567 4.11626 2.05034 3.92175 1.85584C3.72728 1.66133 3.41192 1.66133 3.21742 1.85584C1.80638 3.26687 1.0293 5.14291 1.0293 7.13842C1.0293 7.41348 1.25229 7.63647 1.52734 7.63647Z",
                      fill: "#3C434D"
                    }
                  })
                ]
              ),
              _vm._v(" "),
              _c("span", { staticClass: "notification" }, [
                _vm._v("Últimas notificações")
              ]),
              _vm._v(" "),
              _c(
                "b-button-group",
                {
                  staticStyle: {
                    "border-radius": "10px",
                    height: "24px",
                    position: "absolute",
                    right: "15px",
                    top: "34px"
                  },
                  attrs: { size: "sm" }
                },
                [
                  _vm.bMore == false
                    ? _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-popover",
                              rawName: "v-b-popover.hover",
                              value: {
                                customClass: "tooltip-class",
                                content: "Opções de Visibilidade"
                              },
                              expression:
                                "{ customClass: 'tooltip-class', content: 'Opções de Visibilidade'}",
                              modifiers: { hover: true }
                            }
                          ],
                          staticStyle: {
                            "border-radius": "10px 10px 10px 10px"
                          },
                          attrs: { variant: "blank" },
                          on: { click: _vm.OpenFilterNotification }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-tags",
                            staticStyle: { "font-size": "18px" },
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.bMore == true
                    ? _c(
                        "b-button",
                        {
                          directives: [
                            {
                              name: "b-popover",
                              rawName: "v-b-popover.hover",
                              value: {
                                customClass: "tooltip-class",
                                content: "Opções de Visibilidade"
                              },
                              expression:
                                "{ customClass: 'tooltip-class', content: 'Opções de Visibilidade'}",
                              modifiers: { hover: true }
                            }
                          ],
                          staticStyle: {
                            "border-radius": "10px 10px 10px 10px",
                            color: "#0d0d0d"
                          },
                          attrs: { variant: "blank" },
                          on: { click: _vm.FilterNotifications }
                        },
                        [
                          _c("i", {
                            staticClass: "fa fa-tags",
                            staticStyle: { "font-size": "18px" },
                            attrs: { "aria-hidden": "true" }
                          })
                        ]
                      )
                    : _vm._e()
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "b-card",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showVisibilityOptions,
                      expression: "showVisibilityOptions"
                    }
                  ],
                  staticClass: "opcoes",
                  staticStyle: {
                    position: "absolute",
                    "z-index": "1000",
                    "border-bottom-color": "#B4B8C0",
                    right: "4px",
                    top: "67px"
                  },
                  attrs: { variant: "primary", "bg-variant": "white" }
                },
                [
                  _c(
                    "b-form-group",
                    { attrs: { label: "Opções de visibilidade" } },
                    [
                      _c("br"),
                      _vm._v(" "),
                      _c("b-form-checkbox-group", {
                        attrs: { stacked: "", options: _vm.visibleOptions },
                        on: { change: _vm.checkVisibleOptions },
                        model: {
                          value: _vm.visibleOptionsSelected,
                          callback: function($$v) {
                            _vm.visibleOptionsSelected = $$v
                          },
                          expression: "visibleOptionsSelected"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _vm.notifications.length == 0
            ? _c(
                "div",
                {
                  staticClass: "tabela-cognatis-nenhum",
                  staticStyle: { "margin-left": "-15px" }
                },
                [_vm._v("\n      Não há novas notificações\n    ")]
              )
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticStyle: {
            "overflow-x": "auto",
            "max-height": "600px",
            "min-height": "108px"
          }
        },
        [
          _vm.notifications.length != 0
            ? _c("table", { staticClass: "table" }, [
                _c(
                  "tbody",
                  _vm._l(_vm.FilterNotifications(), function(item) {
                    return _c("tr", { key: item.nId }, [
                      _c("th", { attrs: { scope: "row" } }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              width: "8",
                              height: "8",
                              viewBox: "0 0 8 8",
                              fill: "none",
                              xmlns: "http://www.w3.org/2000/svg"
                            }
                          },
                          [
                            item.cType == "News"
                              ? _c("circle", {
                                  attrs: {
                                    cx: "4",
                                    cy: "4",
                                    r: "4",
                                    fill: "#3FAD58"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            item.cType == "Warning"
                              ? _c("circle", {
                                  attrs: {
                                    cx: "4",
                                    cy: "4",
                                    r: "4",
                                    fill: "#ffaa00"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            item.cType == "Info"
                              ? _c("circle", {
                                  attrs: {
                                    cx: "4",
                                    cy: "4",
                                    r: "4",
                                    fill: "#0c85d0"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            item.cType == "Error"
                              ? _c("circle", {
                                  attrs: {
                                    cx: "4",
                                    cy: "4",
                                    r: "4",
                                    fill: "#a10f18"
                                  }
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            item.cType != "Info" &&
                            item.cType != "Error" &&
                            item.cType != "cType" &&
                            item.cType != "News"
                              ? _c("circle", {
                                  attrs: {
                                    cx: "4",
                                    cy: "4",
                                    r: "4",
                                    fill: "#B4B8C0"
                                  }
                                })
                              : _vm._e()
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", { staticClass: "table-text" }, [
                        _c("strong", [_vm._v(_vm._s(item.cTitle) + ":")]),
                        _vm._v(" " + _vm._s(item.cShortMessage))
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm.formatDate(item.dtCreated)))
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _c(
                          "a",
                          {
                            attrs: { href: "#" },
                            on: {
                              click: function($event) {
                                return _vm.MarkAsRead(item.nId)
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "material-icons" }, [
                              _vm._v(" close ")
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticStyle: { display: "none" } },
                        _vm._l(item.jbAction, function(action, key) {
                          return _c(
                            "b-button-group",
                            { key: key },
                            [
                              _c(
                                "b-button",
                                {
                                  staticClass: "mr-1",
                                  attrs: { size: "sm", variant: "info" },
                                  on: {
                                    click: function($event) {
                                      $event.stopPropagation()
                                      $event.preventDefault()
                                      return _vm.CallActionMethod(action, item)
                                    }
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                    " +
                                      _vm._s(action.alias) +
                                      "\n                  "
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        }),
                        1
                      )
                    ])
                  }),
                  0
                )
              ])
            : _vm._e()
        ]
      ),
      _vm._v(" "),
      _c(
        "footer",
        [
          _vm.notifications.length != 0
            ? _c(
                "b-btn",
                {
                  staticStyle: { width: "100%" },
                  attrs: { variant: "link", size: "sm" },
                  on: {
                    click: function($event) {
                      return _vm.MarkAllAsRead()
                    }
                  }
                },
                [_vm._v("\n      Marcar todas como lida\n    ")]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm._m(0)
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "my-modal",
          attrs: {
            id: "my-modalId",
            title: "Mensagem",
            size: "lg",
            scrollable: "",
            "hide-backdrop": "",
            "no-close-on-backdrop": ""
          },
          model: {
            value: _vm.showModalLongMessage,
            callback: function($$v) {
              _vm.showModalLongMessage = $$v
            },
            expression: "showModalLongMessage"
          }
        },
        [_vm._v("\n    " + _vm._s(_vm.sLongMessage) + "\n  ")]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "div",
      {
        staticClass: "notif-anterior",
        staticStyle: { "border-top": "1px solid #E8E8E8", padding: "20px" }
      },
      [
        _c("a", { attrs: { href: "#" } }, [
          _vm._v("Ver notificações anteriores")
        ])
      ]
    )
  }
]
render._withStripped = true

export { render, staticRenderFns }